export default __webpack_public_path__ + "static/flag_w.1459aed3d7fbf3734b44127f879a8ae3.svg";